<!--
  Component: ParagraphBreak

  This component creates a plain div of text, classed with 'ParagraphBreak'
  for CSS formatting.

  Note: ParagraphBreak doesn’t need metadata mixins unless we want to attach metadata.

  The purpose is to avoid frequently changing CSS in other components by adding margins or padding.
  Instead, we can just modify the metadata by inserting this component below the target component.
-->
<template>
  <div class="paragraph-break"></div>
</template>
<script>
import Component from 'vue-class-component'

import MetadataBase from './MetadataBase'

@Component({
})
export default class ParagraphBreak extends MetadataBase {}
</script>

<style lang="scss" scoped>
.paragraph-break {
  height: 1em;
}
</style>



// WEBPACK FOOTER //
// src/components/sqs/2025/tab-mods/ParagraphBreak.vue